import axios, {AxiosRequestConfig} from 'axios';
import {encodeGetParams} from './common';
import { message } from 'antd';
import {getQueryParams, ObjTest} from 'jzfz-web-utils';
import { createHashHistory } from 'history';
import {EnvEnum, GLOBAL_ENV} from "../config/constant";


const hashHistory = createHashHistory();
// axios实例
const instance = axios.create();
// 登出防抖
let logoutDebounce = null;
// 接口返回状态码枚举
export enum APIStatusEnum {
	error = 0,  // 发生错误
	SUCCESS = 1,	// 成功
	notLogin = 401, // 未登录
	forbidden = 403,    // 拒绝访问
}


// 请求配置接口
interface IRequestOptions extends AxiosRequestConfig {
	callback?: (info: any) => void;
	isLog?: boolean;    // 是否是日志类型请求(不对接口响应做任何处理)
	onUploadProgress?: (progressEvent: any) => void;
}


/**
 * 获取请求头
 */
export const getHeaders = (): any => {
	return {};
}


/**
 * 服务器状态码检查
 * @param status
 */
const httpStatusCheck = (status) => {
	let msg = '连接服务器失败';
	switch (status) {
		case 400: msg = '请求错误(400)' ; break;
		case 401: msg = '未授权，请重新登录(401)'; break;
		case 403: msg = '拒绝访问(403)'; break;
		case 404: msg = '请求出错(404)'; break;
		case 408: msg = '请求超时(408)'; break;
		case 500: msg = '服务器错误(500)'; break;
		case 501: msg = '服务未实现(501)'; break;
		case 502: msg = '网络错误(502)'; break;
		case 503: msg = '服务不可用(503)'; break;
		case 504: msg = '网络超时(504)'; break;
		case 505: msg = 'HTTP版本不受支持(505)'; break;
		default: msg = `连接出错(${status})!`;
	}
	message.error(msg + '，请稍后再试');
	return Promise.reject(msg);
}


/**
 * 路由重定向
 */
const routeRedirect = () => {
	const history = createHashHistory();
	const { pathname } = history.location;
	if (logoutDebounce) {
		clearTimeout(logoutDebounce);
	}
	if (pathname === '/login') {
		return;
	}

	logoutDebounce = setTimeout(() => {
		const { pathname } = history.location;
		history.replace({pathname: '/login', search: encodeGetParams({...getQueryParams(), from: pathname})});
	}, 3000)
}


/**
 * 接口状态码检查
 * @param res
 * @param config
 */
const codeCheck = (res: any, config: IRequestOptions) : Promise<any> => {
	if (res.status == APIStatusEnum.notLogin) {
		message.warning(res.info, 3);
		routeRedirect();
		return Promise.reject(res.info);
	}
	if (res.status == APIStatusEnum.error || res.status === APIStatusEnum.forbidden) {
		if (config.isLog) {
			return Promise.reject(res.info);
		}
		if (config.callback && typeof config.callback == 'function') {
			config.callback(res);
		}else {
			message.error(res.info);
		}
		return Promise.reject(res.info);
	}
	return res;
}


/**
 * 自定义参数序列化
 */
const paramsSerializer = (params): string => {
	return encodeGetParams(params);
}


/**
 * 接口日志
 * @param res
 */
const apiLog = (res: any) => {
	// 开发、测试环境才打印日志
	if (GLOBAL_ENV === EnvEnum.DEV || GLOBAL_ENV === EnvEnum.TEST) {
		if (!res) {
			return;
		}
		const { data: responseData, config: {url, headers, data, params}, status: httpCode } = res;
		if (httpCode !== 200 || (ObjTest.isObj(responseData) && responseData.status !== APIStatusEnum.SUCCESS)) {
			const { info } = responseData || {};
			let logInfo = [
				`【${httpCode === 200 ? '接口异常' : '服务器错误'}】\n`,
				`HttpCode: ${httpCode}\n`,
				`接口路径: ${url}\n`,
				`请求头: ${JSON.stringify(headers)}\n`,
				`请求参数: ${data || params || ''}\n`,
				`响应信息: ${info || ''}`
			].join('');
			console.info(`%c${logInfo}`, 'color: red;font-size: 16px;font-weight: bold;');
		}
	}
}


/**
 * 定义响应拦截器
 */
instance.interceptors.response.use((res: any) => {
	apiLog(res);
	return res;
}, (err: any) => {
	if (axios.isCancel(err)) {
		return Promise.reject('请求已取消');
	}

	apiLog(err.response);
	if (err.response && 'status' in err.response) {
		return httpStatusCheck(err.response.status);
	}
	message.error('服务器无响应');
	return Promise.reject('服务器无响应');
});


/**
 * 自定义请求函数
 * @param url
 * @param body
 * @param options
 */
export const request = (url: string, body: object = {}, options?: IRequestOptions): Promise<any> => {
	const { method = 'post', isLog, callback, onUploadProgress, ...restOptions } = options || {};
	return instance({
		url,
		method,
		data: (method.toLowerCase() == 'post' ? body : {}),
		params: (method.toLowerCase() == 'get' ? body : {}),
		timeout: 200000,
		headers: getHeaders(),
		paramsSerializer,
		...restOptions,
	}).then((res: any) => {
		return codeCheck(res.data, options);
	})
}
